import styled from "styled-components";

export const Legend = styled.div`
  transform: translateX(16px);
  text-align: center;
`;
